import { useTranslation } from "react-i18next";

export default function AboutUsSection() {
  const { t } = useTranslation();

  const values = [
    { icon: "ri-medal-line", titleKey: "about_val1_title", descKey: "about_val1_desc" },
    { icon: "ri-hand-heart-line", titleKey: "about_val2_title", descKey: "about_val2_desc" },
    { icon: "ri-lock-line", titleKey: "about_val3_title", descKey: "about_val3_desc" },
    { icon: "ri-lightbulb-flash-line", titleKey: "about_val4_title", descKey: "about_val4_desc" },
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top: intro */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center mb-20">
          {/* Text */}
          <div>
            <span className="text-[#D4927A] text-sm font-semibold tracking-widest uppercase">{t("about_tag")}</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1C2331] mt-2 mb-5 leading-tight">
              {t("about_heading")}
            </h2>
            <p className="text-[#6B7280] text-sm leading-relaxed mb-4">{t("about_p1")}</p>
            <p className="text-[#6B7280] text-sm leading-relaxed mb-6">{t("about_p2")}</p>
            <p className="text-[#6B7280] text-sm leading-relaxed mb-8">{t("about_p3")}</p>
          </div>

          {/* Image */}
          <div className="rounded-2xl overflow-hidden h-[440px]">
            <img
              src="https://public.readdy.ai/ai/img_res/6fa216bebc54245e2936644183ea1bc6.jpg"
              alt="Nice Accounting Team"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Values */}
        <div>
          <div className="text-center mb-10">
            <h3 className="text-2xl font-bold text-[#1C2331]">{t("about_values_heading")}</h3>
            <p className="text-[#6B7280] text-sm mt-2">{t("about_values_sub")}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v) => (
              <div
                key={v.titleKey}
                className="bg-[#FAFAF8] border border-gray-100 rounded-2xl p-6 hover:border-[#D4927A]/30 hover:bg-white transition-all duration-300 group cursor-pointer"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#FAE8DF] group-hover:bg-[#D4927A] transition-colors mb-4">
                  <i className={`${v.icon} text-xl text-[#D4927A] group-hover:text-white transition-colors`} />
                </div>
                <h4 className="font-bold text-[#1C2331] text-sm mb-2">{t(v.titleKey)}</h4>
                <p className="text-[#6B7280] text-xs leading-relaxed">{t(v.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
